import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import adminStore from '../../../store/Admin';
import { Typography } from '@mui/material';
import { AddCircleOutline, RemoveCircleOutline } from '@mui/icons-material';
import CreditModal from './CreditModal';
import BaseAccordion from '../../../components/Accordion';
import BaseTable from '../../../components/BaseTable';

const Credits: FC = observer(() => {
  const [companiesTableData, setCompaniesTableData] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState<any>(null);

  useEffect(() => {
    const getTableData = async () => {
      const data = await adminStore.getUsersWithCredits();
      if (data) {
        setCompaniesTableData(data);
      }
    };
    getTableData();
  }, []);

  const handleCredit = async (
    action: 'grant' | 'deduct',
    type: 'user' | 'company',
    customer: string,
    balance: number
  ) => {
    setModalData({ action, customer, balance, type });
    setOpenModal(true);
  };

  const closeModal = (reloadData: boolean = false) => {
    setOpenModal(false);
    setModalData(null);
    if (reloadData) {
      adminStore.getUsersWithCredits().then((data) => {
        setCompaniesTableData(data);
      });
    }
  };

  const getTableDefinition = (companyName: string) => {
    return [
      { key: 'username', header: 'Username' },
      { key: 'email', header: 'Email' },
      { key: 'spent_credits', header: 'Credits spent this month' },
    ];
  };

  const getAccordionTitle = (data: any) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div>
          <Typography style={{ fontWeight: 'bold' }} component='span'>
            {data.company}
          </Typography>
        </div>
        <div
          style={{
            fontWeight: 'bold',
            color: '#ff5f1f',
            marginRight: '15px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography component='span' sx={{ marginRight: '15px' }}>
            Credits: {data.credits}
          </Typography>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <AddCircleOutline
              color='success'
              sx={{ cursor: 'pointer' }}
              onClick={() =>
                handleCredit('grant', 'company', data.company, data.credits)
              }
            />
            <RemoveCircleOutline
              color='error'
              sx={{ ml: '15px', cursor: 'pointer' }}
              onClick={() =>
                handleCredit('deduct', 'company', data.company, data.credits)
              }
            />
          </div>
        </div>
      </div>
    );
  };

  const renderCompanies = () => {
    return companiesTableData.map((data: any, index: any) => {
      const isLast = index === companiesTableData.length - 1;
      return (
        <BaseAccordion
          sx={isLast ? {} : { mb: '0.5rem' }}
          title={getAccordionTitle(data)}
          key={`company_${index}`}
        >
          <BaseTable
            columns={getTableDefinition(data.company)}
            tableData={data.users}
          />
        </BaseAccordion>
      );
    });
  };

  return (
    <div>
      <h2>Credits Dashboard</h2>
      {renderCompanies()}
      {openModal && (
        <CreditModal
          open={openModal}
          handleClose={closeModal}
          data={modalData}
        />
      )}
    </div>
  );
});

export default Credits;
